"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var appThemeDefault = {
    menu: {
        width: "100%",
    },
};
exports.default = appThemeDefault;
//# sourceMappingURL=app-theme-defaule.js.map